import type { PrestationTone } from '../../contractStatusTone'
import {
  EmptyValue,
  OfferDetail,
  OfferDetailValue,
  OfferDetails,
  PrestationChip,
  ProviderLine,
  SecondaryLine,
} from '../../styled-components'

interface OfferCellProps {
  hasOffer: boolean
  emptyLabel: string
  provider: string
  name: string
  prestation: string
  prestationTone: PrestationTone
  details: Array<{ key: string; label: string; value: string }>
}

const OfferCell = ({ hasOffer, emptyLabel, provider, name, prestation, prestationTone, details }: OfferCellProps) => {
  if (!hasOffer) return <EmptyValue>{emptyLabel}</EmptyValue>

  return (
    <>
      <ProviderLine>
        {provider}
        <PrestationChip $tone={prestationTone} $hidden={!prestation}>
          {prestation}
        </PrestationChip>
      </ProviderLine>
      <SecondaryLine>{name}</SecondaryLine>
      <OfferDetails $hidden={details.length === 0}>
        {details.map(detail => (
          <OfferDetail key={detail.key}>
            {detail.label}
            <OfferDetailValue>{detail.value}</OfferDetailValue>
          </OfferDetail>
        ))}
      </OfferDetails>
    </>
  )
}

export default OfferCell
